import sample_1 from './sample_1.png';

export const basicsAllround = {
    sample_1,
};
